import React, { useEffect, useState } from "react";
import { XMarkIcon, CheckIcon } from "@heroicons/react/24/outline";
import { toast } from "react-toastify";

interface ClientSelectModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  baseValue: string; // contains CLIENT_ID
  clients: any[];
}

const ClientSelectModal: React.FC<ClientSelectModalProps> = ({
  isOpen,
  onClose,
  title,
  baseValue,
  clients,
}) => {
  const [selectedClientId, setSelectedClientId] = useState<string>("");

  useEffect(() => {
    if (!isOpen) setSelectedClientId("");
  }, [isOpen]);

  if (!isOpen) return null;

  const finalValue = selectedClientId
    ? baseValue.replace("CLIENT_ID", selectedClientId)
    : baseValue;

  const copy = async () => {
    if (!selectedClientId) {
      toast.error("Please select a client");
      return;
    }
    await navigator.clipboard.writeText(finalValue);
    toast.success("Copied with Client ID!");
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center">
      <div className="bg-white rounded-xl w-full max-w-2xl p-6 relative">
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-gray-500 hover:text-gray-700"
        >
          <XMarkIcon className="h-5 w-5" />
        </button>

        <h3 className="text-lg font-semibold mb-4">{title}</h3>

        {/* Client Select */}
        <label className="text-sm font-medium text-gray-700">
          Select Client
        </label>
        <select
          value={selectedClientId}
          onChange={(e) => setSelectedClientId(e.target.value)}
          className="w-full mt-1 mb-4 border rounded-lg px-3 py-2 text-sm"
        >
          <option value="">-- Select Client --</option>
          {clients.map((c: any) => (
            <option key={c.clientId} value={c.clientId}>
              {c.name} ({c.clientId})
            </option>
          ))}
        </select>

        {/* Preview */}
        <div className="bg-gray-50 border rounded-lg p-3 mb-4">
          <pre className="text-xs whitespace-pre-wrap break-all">
            {finalValue}
          </pre>
        </div>

        {/* Actions */}
        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm border rounded-lg"
          >
            Cancel
          </button>
          <button
            onClick={copy}
            className="px-4 py-2 text-sm bg-blue-600 text-white rounded-lg flex items-center gap-1"
          >
            <CheckIcon className="h-4 w-4" />
            Copy
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClientSelectModal;
